// --- src/components/ui/BackButton.jsx ---
import { useNavigate } from "react-router-dom"
import { ArrowLeft } from "lucide-react"
import { Button } from "@/components/ui/button"

export function BackButton({ to, label = "Back" }) {
    const navigate = useNavigate()

    return (
        <Button
            variant="ghost"
            className="flex items-center gap-2 text-sm w-fit"
            onClick={() => navigate('/candidate/profile')}
        >
            <ArrowLeft className="w-4 h-4" />
            {label}
        </Button>
    )
}
